<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="flex justify-center px-4">
      <div
        class="tablet relative flex flex-col items-start rounded bg-white p-8"
      >
        <img
          class="absolute right-4 top-4 h-4 w-4 cursor-pointer"
          src="@/assets/close-icon.svg"
          alt="cose icon"
          @click="$emit('close')"
        />

        <h3 class="mb-4 text-3xl text-dark-blue">Save and Exit</h3>
        <p class="mb-4 flex flex-wrap text-left text-body-color">
          Are you sure you want to exit the onboarding process? Your progress
          will be saved.
        </p>
        <span
          class="w-full md:ml-auto md:flex md:w-2/3 md:flex-row-reverse md:gap-x-2"
        >
          <button-main @click="onExitSuccess">Save & Exit</button-main>
          <button-main
            variant="secondary"
            class="mt-3 md:mt-0"
            @click="$emit('close')"
          >
            Cancel
          </button-main>
        </span>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'SaveAndQuitModal',
  components: {
    Modal,
    ButtonMain,
  },
  props: {
    visible: Boolean,
  },
  emits: ['close', 'quit'],
  setup(_, { emit }) {
    const onCancel = () => {
      emit('close');
    };
    const onExitSuccess = () => {
      emit('quit');
      emit('close');
    };

    return {
      onCancel,
      onExitSuccess,
    };
  },
};
</script>

<style scoped>
@media (min-width: 768px) {
  .tablet {
    width: 500px;
  }
}
</style>
